import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';

@Component({
  selector: 'gc-floating-popup-content-export-csv-actions',
  standalone: true,
  imports: [ButtonModule, SvgIconComponent, TranslatePipe, TranslateDirective, Tooltip],
  templateUrl: './floating-popup-content-export-csv-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupContentExportCsvActionsComponent {
  public readonly scrRes = inject(ScreenResolutionService);
  public isDisabled = input(false);
  public isLabelHidden = input<boolean>(false);
  public export = output<void>();
}
